import React, { useState, useEffect } from 'react';
import './TOUModal.css';

const TOUModal = ({ isOpen, onAccept, touContent, privacyContent }) => {
  const [activeTab, setActiveTab] = useState('tou');
  const [hasScrolledTOU, setHasScrolledTOU] = useState(false);
  const [hasScrolledPrivacy, setHasScrolledPrivacy] = useState(false);
  const [touAgreed, setTouAgreed] = useState(false);
  const [privacyAgreed, setPrivacyAgreed] = useState(false);

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setActiveTab('tou');
      setHasScrolledTOU(false);
      setHasScrolledPrivacy(false);
      setTouAgreed(false);
      setPrivacyAgreed(false);
    }
  }, [isOpen]);

  const handleScroll = (e) => {
    const element = e.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
    
    if (atBottom) {
      if (activeTab === 'tou') {
        setHasScrolledTOU(true);
      } else {
        setHasScrolledPrivacy(true);
      }
    }
  };

  const canAccept = touAgreed && privacyAgreed && hasScrolledTOU && hasScrolledPrivacy;

  if (!isOpen) return null;

  return (
    <div className="tou-modal-overlay">
      <div className="tou-modal">
        <div className="tou-modal-header">
          <h2>Terms & Conditions</h2>
          <p className="tou-subtitle">Please review and accept our Terms of Use and Privacy Policy to continue</p>
        </div>

        <div className="tou-tabs">
          <button
            className={`tou-tab ${activeTab === 'tou' ? 'active' : ''}`}
            onClick={() => setActiveTab('tou')}
          >
            Terms of Use
            {hasScrolledTOU && touAgreed && <span className="check-mark">✓</span>}
          </button>
          <button
            className={`tou-tab ${activeTab === 'privacy' ? 'active' : ''}`}
            onClick={() => setActiveTab('privacy')}
          >
            Privacy Policy
            {hasScrolledPrivacy && privacyAgreed && <span className="check-mark">✓</span>}
          </button>
        </div>

        <div className="tou-content" onScroll={handleScroll}>
          {activeTab === 'tou' && touContent && (
            <div className="tou-document">
              <h3>{touContent.content.title}</h3>
              <p className="version-info">
                Version {touContent.version} | Last Updated: {touContent.lastUpdated}
              </p>
              {touContent.content.sections.map((section, index) => (
                <div key={index} className="tou-section">
                  <h4>{section.heading}</h4>
                  <p>{section.content}</p>
                </div>
              ))}
              {!hasScrolledTOU && (
                <div className="scroll-indicator">
                  <p>↓ Please scroll to the bottom to continue ↓</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'privacy' && privacyContent && (
            <div className="tou-document">
              <h3>{privacyContent.content.title}</h3>
              <p className="version-info">
                Version {privacyContent.version} | Last Updated: {privacyContent.lastUpdated}
              </p>
              {privacyContent.content.sections.map((section, index) => (
                <div key={index} className="tou-section">
                  <h4>{section.heading}</h4>
                  <p>{section.content}</p>
                </div>
              ))}
              {!hasScrolledPrivacy && (
                <div className="scroll-indicator">
                  <p>↓ Please scroll to the bottom to continue ↓</p>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="tou-checkboxes">
          <label className={`tou-checkbox ${!hasScrolledTOU ? 'disabled' : ''}`}>
            <input
              type="checkbox"
              checked={touAgreed}
              onChange={(e) => setTouAgreed(e.target.checked)}
              disabled={!hasScrolledTOU}
            />
            <span>I have read and agree to the Terms of Use</span>
          </label>
          <label className={`tou-checkbox ${!hasScrolledPrivacy ? 'disabled' : ''}`}>
            <input
              type="checkbox"
              checked={privacyAgreed}
              onChange={(e) => setPrivacyAgreed(e.target.checked)}
              disabled={!hasScrolledPrivacy}
            />
            <span>I have read and agree to the Privacy Policy</span>
          </label>
        </div>

        <div className="tou-actions">
          <button
            className="tou-accept-btn"
            onClick={onAccept}
            disabled={!canAccept}
          >
            Accept & Continue
          </button>
          <p className="tou-note">
            You must accept both documents to use The Ascended platform
          </p>
        </div>
      </div>
    </div>
  );
};

export default TOUModal;
